/**
 * QR Code API Client
 * ───────────────────
 */
import { apiClient } from './api';

export interface QRCodeRecord {
  id: string;
  code: string;
  entity_type: string;
  entity_id: string;
  farmer_id: string | null;
  payload: any;
  scan_count: number;
  created_at: string;
  last_scanned_at: string | null;
  farmer_name?: string;
}

export const qrApi = {
  generate: async (entityType: string, entityId: string, farmerId?: string, payload?: any): Promise<QRCodeRecord> => {
    const res = await apiClient.post('/qr/generate', { entityType, entityId, farmerId, payload });
    return res.data;
  },

  getBatchQR: async (batchId: string): Promise<QRCodeRecord> => {
    const res = await apiClient.get(`/qr/batch/${batchId}`);
    return res.data;
  },

  getFarmerQRCodes: async (farmerId: string): Promise<{ codes: QRCodeRecord[]; count: number }> => {
    const res = await apiClient.get(`/qr/farmer/${farmerId}`);
    return res.data;
  },

  getAll: async (limit = 100): Promise<{ codes: QRCodeRecord[]; count: number }> => {
    const res = await apiClient.get('/qr/all', { params: { limit } });
    return res.data;
  },

  getStats: async (): Promise<any> => {
    const res = await apiClient.get('/qr/stats');
    return res.data;
  },

  /** Public resolve — no auth needed, uses fetch directly.
   *  v2.1.1 (BUG#A1 fix): relative URL — works in any env (local, prod, preview).
   *  Previously hardcoded http://localhost:5000 which broke QR scans everywhere
   *  except local dev. */
  resolve: async (code: string): Promise<any> => {
    const res = await fetch(`/api/qr/resolve/${code}`);
    if (!res.ok) throw new Error('Invalid QR code');
    return res.json();
  },
};

export default qrApi;
